export default __webpack_public_path__ + "static/mae-right-a940c33c6ae6134fbb99f4665dc4dbb4.svg";